import React from 'react'

export const Loader = ({small = false}) => {
    return <div className={`lds-ring ${small ? 'small-loader' : ''}`}><div></div><div></div><div></div><div></div></div>
}

